import { createFileRoute } from '@tanstack/react-router';
import styled from 'styled-components';
import api from '@/api';
import { Badge } from '~/components/ui/Badge';
import { OnboardingHeader } from '~/components/ui/ContentNav';
import { Field, FieldLabel, FieldValue } from '~/components/ui/FieldDisplay';
import { FieldGrid, Section, SectionTitle } from '~/components/ui/Section';

export const Route = createFileRoute('/_admin/onboardings/$onboardingId')({
  component: OnboardingDetail,
});

function OnboardingDetail() {
  const { onboardingId } = Route.useParams();
  const { data, isLoading, error } = api.getOnboardingSequence.useQuery({
    path: { onboarding_id: Number(onboardingId) },
  });

  if (isLoading) return <Message>Loading onboarding...</Message>;
  if (error) return <Message $error>Error loading onboarding</Message>;
  if (!data) return <Message $error>Onboarding not found</Message>;

  return (
    <Container>
      <OnboardingHeader onboardingId={data.id} />

      <Section>
        <SectionTitle>Details</SectionTitle>
        <FieldGrid>
          <Field>
            <FieldLabel>ID</FieldLabel>
            <FieldValue>{data.id}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>Language</FieldLabel>
            <FieldValue>
              <Badge $variant="neutral">{data.language}</Badge>
            </FieldValue>
          </Field>
          <Field>
            <FieldLabel>Activation Condition</FieldLabel>
            <FieldValue>{data.activation_condition ?? '—'}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>Slides</FieldLabel>
            <FieldValue>{data.slides.length}</FieldValue>
          </Field>
        </FieldGrid>
      </Section>
    </Container>
  );
}

const Container = styled.div``;

const Message = styled.div<{ $error?: boolean }>`
  padding: 2rem;
  text-align: center;
  color: ${(p) => (p.$error ? 'var(--error)' : 'var(--grey-600)')};
`;
